<template>
    <div class="content content--registration">
        <div class="small-window">
            <div class="form-wrap">
                <h1 class="form-wrap__title form-wrap__title--sticky">Трудоустройство</h1>

                <div class="form-wrap__row">
                    <c-radio-group v-model="workType" :valueList="workTypeList" :label="'Тип занятости'"
                                   :fieldName="'workType'"
                                   v-on:change="selectWorkType"></c-radio-group>
                </div>

                <div class="form-wrap__row" v-if="notUnemployment">
                    <c-input
                            :label="'Место работы'"
                            :type="'text'"
                            :fieldName="'workPlace'"

                            :externalStatus="workPlaceExternalStatus"
                            v-model="workPlace"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>

                <div class="form-wrap__row" v-if="notUnemployment">
                    <c-input
                            :label="'Рабочий телефон'"
                            :type="'tel'"
                            :fieldName="'workPhone'"
                            :validation="'decimal'"
                            :mask="'+7(###)###-##-##'"

                            :externalStatus="workPhoneExternalStatus"
                            v-model="workPhone"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>

                <div class="form-wrap__row" v-if="notUnemployment">
                    <c-input
                            :label="'Дополнительный номер'"
                            :type="'tel'"
                            :fieldName="'additionalPhone'"
                            :validation="'decimal'"

                            :externalStatus="workAdditionalPhoneExternalStatus"
                            v-model="workAdditionalPhone"
                    >
                        <template slot="hint"></template>
                        <template slot="tooltip"></template>
                    </c-input>
                </div>
                <div class="form-wrap__row" v-if="isCompleteBlock('workInfo') || workInfoFilled">
                    <p class="form-wrap__text-info"></p>
                    <div class="form-button__wrap">
                        <router-link :to="{name: 'AdditionalIncome'}"
                                     @click.native="save(['workInfo'])"
                                     tag="button" class="form-button form-button--yellow form-button--long-text">
                            Продолжить
                        </router-link>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
    import {createHelpers} from 'vuex-map-fields';
    import store from '@/storage/index'
    import {GET_PROFILE} from "@/storage/mutations";
    import {TOGGLE_LOADER} from "@/storage/mutations";
    import {STATUSES} from "@/components/statuses";
    import registrationMixins from '@/modules/mixins/registrationMixins'

    const {mapFields} = createHelpers({
        getterType: 'profile/getField',
        mutationType: 'profile/updateField',
    });

    const UNEMPLOYMENT_TYPES = [
        'PENSIONER',
        'STUDENT',
        'HOUSEWIFE',
        'UNEMPLOYED'
    ];


    export default {
        name: 'Employment',
        mixins: [registrationMixins],
        metaInfo: {
            title: 'Регистрация'
        },
        data() {
            return {
                workTypeList: [
                    {
                        label: 'Пенсионер',
                        value: 'PENSIONER'
                    },
                    {
                        label: 'Студент',
                        value: 'STUDENT'
                    },
                    {
                        label: 'Домохозяйка',
                        value: 'HOUSEWIFE'
                    },
                    {
                        label: 'Безработный',
                        value: 'UNEMPLOYED'
                    },
                    {
                        label: 'Самозанятый (ИП)',
                        value: 'INDIVIDUAL_ENTREPRENEUR'
                    },
                    {
                        label: 'Работник / Служащий',
                        value: 'FULL_TIME_EMPLOYMENT'
                    },
                    {
                        label: 'Владелец предприятия /компании',
                        value: 'BUSINESS_OWNER'
                    },
                    {
                        label: 'Высший руководитель компании',
                        value: 'TOP_MANAGER'
                    },
                    {
                        label: 'Частичная занятость',
                        value: 'PART_TIME_EMPLOYMENT'
                    },
                    {
                        label: 'Руководитель среднего звена',
                        value: 'MIDDLE_MANAGER'
                    },
                    {
                        label: 'Декретный отпуск',
                        value: 'MATERNITY_LEAVE'
                    },
                    {
                        label: 'Прочее',
                        value: 'OTHER'
                    },


                ]
            }
        },
        watch: {},
        methods: {},
        asyncComputed: {},
        computed: {
            workInfoFilled : function(){
              return this.workPlace !== '' && this.workPhone !== '';
            },
            notUnemployment: function () {
                return UNEMPLOYMENT_TYPES.indexOf(this.workType) === -1 && this.workType !== '';
            },
            clearPhone: function () {
                return this.workPhone.replace(/[^0-9.]/g, "");
            },
            ...mapFields([
                'workType',
                'workTypeExternalStatus',
                'workTypeExternalError',

                'workPlace',
                'workPlaceExternalStatus',
                'workPlaceExternalError',

                'workPhone',
                'workPhoneExternalStatus',
                'workPhoneExternalError',

                'workAdditionalPhone',
                'workAdditionalPhoneExternalStatus',
                'workAdditionalPhoneExternalError',
            ]),
        },
        mounted() {
            this.$store.commit('CHANGE_PROGRESS', {progressBarShow: true, currentPercent: 50, nextPercent: 10});
        }
    }
</script>

<style lang="scss">

</style>